module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-logo-winter-film festival.45cdc92.jpg";